function search(query) {
    // If the search json is not loaded yet do nothing.
    if(searchJson == null)
        return;

    // Get the result list element and clear it.
    var resultList;
    if(resultList = document.querySelector('ul.home.post-list.search-result'))
        resultList.innerHTML = '';

    // If no query was entered 'unhide' the main content and paginator and return
    if(query == "") {
        if(x = document.querySelector('.main-content')) x.classList.remove('hide');
        if(x = document.querySelector('.paginator'))    x.classList.remove('hide');
        return;
    }

    // .. else hide them.
    if(x = document.querySelector('.main-content')) x.classList.add('hide');
    if(x = document.querySelector('.paginator'))    x.classList.add('hide');

    // convert the query to lower case to make the search case-insensitive
    query = query.toLowerCase();
    // use the superSplit method to split the query in all possible combinations
    var splitSplitQuery = query.superSplit(" ");

    // calculate the score of each post
    for(var i=0; i < searchJson.length; i++) {
        var post = searchJson[i];
        post.score = 0;
        
        post.contentText = createElement({
            name: 'div',
            innerHTML: post.content.toLowerCase()
        }).innerText;

        // loop through all parts of the query
        for(var j=0; j < splitSplitQuery.length; j++) {
            var splitQuery = splitSplitQuery[j];

            for(var k=0; k < splitQuery.length; k++) {
                var queryPart = splitQuery[k];

                var titleIndexes = post.title.toLowerCase().superIndexOf(queryPart);
                post.score += Math.pow(splitSplitQuery.length - j, 2) * titleIndexes.length * 100

                var contentIndexes = post.content.toLowerCase().superIndexOf(queryPart);
                post.score += Math.pow(splitSplitQuery.length - j, 2) * contentIndexes.length;
                
                // check for categories and tags only when fully split
                if(j == splitSplitQuery.length - 1) {
                    for(var l=0; l < post.categories.length; l++) {
                        if(post.categories[l].toLowerCase().indexOf(queryPart) != -1)
                            post.score += 2000;
                    }
                    for(var l=0; l < post.tags.length; l++) {
                        if(post.tags[l].toLowerCase().indexOf(queryPart) != -1)
                            post.score += 1000;
                    }
                }
            }
        }
    }

    // sort the posts according to their score
    searchJson.sort(function(a, b) {
        if(a.score < b.score)
            return 1;
        if(a.score > b.score)
            return -1;
        return 0;
    });


    // create the search result list element
    if(!resultList) {
        resultList = createElement({
            name: 'ul', 
            classes: 'home post-list search-result', 
            parent: document.querySelector('section.container')
        });
    }
  
    // create the html code for each post
    for(var i=0; i < searchJson.length; i++) {
        // don't show the post if the score is 0
        if(searchJson[i].score == 0)
            break;

        var contentText = searchJson[i].contentText;
        var ranges = [];
        
        // search for the first appearance of each keyword in the posts content
        // and add a range from 100 characters before and after the keyword
        splitSplitQuery.lastElement().forEach(function(keyword) {
            var index = contentText.indexOf(keyword);
            ranges.push(new Range(Math.max(index - 100, 0), Math.min(index + keyword.length + 100, contentText.length)));
        });

        // combine the ranges
        var combinedRanges = Range.combineArray(ranges);

        var resultContentText = "";

        // in each of the remaining ranges mark all keywords
        for(var j=0; j < combinedRanges.length; j++) {
            var part = contentText.substring(combinedRanges[j].start, combinedRanges[j].end);
            var markRanges = [];

            splitSplitQuery.lastElement().forEach(function(keyword) {
                var indexes = part.superIndexOf(keyword);
                for(var k=0; k < indexes.length; k++)
                    markRanges.push(new Range(indexes[k], indexes[k] + keyword.length));
            });

            var combinedMarkRanges = Range.combineArray(markRanges);

            Range.sortArray(combinedMarkRanges);

            var offset = 0;
            for(var k=0; k < combinedMarkRanges.length; k++) {
                part = part.insert(combinedMarkRanges[k].start + offset, "<span class=\"search-keyword\">");
                offset += "<span class=\"search-keyword\">".length;

                part = part.insert(combinedMarkRanges[k].end + offset, "</span>");
                offset += "</span>".length;
            }

            resultContentText += "<p>" + part + "</p>\n";
        }
        
        // create the code for the post
        createElement({
            name: 'li',
            classes: 'post-list-item',
            parent: resultList,
            
            childs: [createElement({
                name: 'article',
                classes: 'post-block',
                
                childs: [
                    createElement({
                        name: 'h2',
                        classes: 'post-title',
                        
                        childs: [createElement({
                            name: 'a',
                            classes: 'post-title-link',
                            href: searchJson[i].url,
                            innerText: searchJson[i].title,
                        })]
                    }),
                    
                    createElement({
                        name: 'div',
                        classes: 'post-content',
                        innerHTML: resultContentText,
                    })
                ]
            })]
        });
    }

    // if no post was found display a "-1"
    if(i == 0) {
        createElement({
            name: 'li',
            classes: 'post-list-item',
            parent: resultList,
            
            childs: [createElement({
                name: 'article',
                classes: 'post-block',

                childs: [createElement({
                    name: 'h3',
                    classes: 'nothing-found',
                    innerText: '-1'
                })]
            })]
        });
    }
}